import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  name: string;
  admin: boolean;
  banned: boolean;
  // Server-set flag (#90): lets QA pick any conversation time instead of the
  // fixed Eastern-time windows. Never settable by the user themselves.
  testAccount: boolean;
}

const initialState: UserState = {
  name: "",
  admin: false,
  banned: false,
  testAccount: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setUserProfile: (
      state,
      action: PayloadAction<{
        name?: string;
        admin?: boolean;
        banned?: boolean;
        testAccount?: boolean;
      }>,
    ) => {
      state.name = action.payload.name ?? "";
      state.admin = action.payload.admin === true;
      state.banned = action.payload.banned === true;
      state.testAccount = action.payload.testAccount === true;
    },
    clearUserName: (state) => {
      state.name = "";
      state.admin = false;
      state.banned = false;
      state.testAccount = false;
    },
  },
});

export const { setUserName, setUserProfile, clearUserName } = userSlice.actions;
export default userSlice.reducer;
